import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'assets/$assetId' }).lazy(() =>
  import('./site-asset.lazy.tsx').then((module) => module.Route),
);
